import top1 from '../../assets/images/top3/top1.png';
import top2 from '../../assets/images/top3/top2.png';
import top3 from '../../assets/images/top3/top3.png';
const medals = [{
    "src": top1,
    "alt": "gold medal with a number 1",
    "name": "#1 favorite"
}, {
    "src": top2,
    "alt": "silver medal with a number 2",
    "name": "#2 favorite"
},{
    "src": top3,
    "alt": "copper medal with a number 3",
    "name": "#3 favorite"
},
]

export default medals;